import { Link } from "react-router";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@bookdental/ui";
import { trpc } from "@/lib/trpc";
import { useIsMobile } from "@/lib/use-media-query";
import { ListaDeSalas, type SalaDaLista } from "@/components/settings/salas/ListaDeSalas";

/** Criar, renomear e desativar salas sem sair de /salas — a mesma lista de Configurações › Salas. */
export function DialogoDeSalas({ aberto, onAbertoChange }: { aberto: boolean; onAbertoChange: (v: boolean) => void }) {
  const isMobile = useIsMobile();
  const consulta = trpc.salas.listar.useQuery({ todas: true }, { enabled: aberto });

  return (
    <Dialog open={aberto} onOpenChange={onAbertoChange}>
      <DialogContent className="flex max-h-[88dvh] max-w-2xl flex-col gap-4 overflow-y-auto border border-zinc-200 bg-white shadow-xl dark:border-border dark:bg-card">
        <DialogHeader>
          <DialogTitle>Gerenciar salas</DialogTitle>
          <DialogDescription>Cada sala é uma cadeira de atendimento: duas consultas nunca ficam na mesma sala ao mesmo tempo.</DialogDescription>
        </DialogHeader>
        {consulta.isLoading ? (
          <Loader2 className="mx-auto my-8 h-5 w-5 animate-spin text-zinc-400" />
        ) : (
          // No celular as cores descem pra segunda linha, pro nome caber.
          <ListaDeSalas salas={(consulta.data ?? []) as SalaDaLista[]} compacta={isMobile} />
        )}
        <p className="text-xs text-zinc-500 dark:text-muted-foreground">
          A sala de cada profissional por dia fica em{" "}
          <Link to="/configuracoes/salas" className="font-semibold text-brand-700 hover:underline dark:text-primary">
            Configurações › Salas
          </Link>
          .
        </p>
      </DialogContent>
    </Dialog>
  );
}
